import { useState } from 'react';
import PublicLayout from './PublicLayout';
import useFetch from './useFetch';
import { getPublic, fmtDate } from './api';

export default function WinnersPage() {
  const [date, setDate] = useState('');
  const { data, loading, error } = useFetch(() => getPublic('/winners', { date, limit: 200 }), [date]);

  const total = data.reduce((sum, w) => sum + (Number(w.win_points) || 0), 0);

  return (
    <PublicLayout
      title="Winners"
      description="Recent winners by date, with their bid and winning points."
    >
      <div className="wrap page">
        <span className="eyebrow">Winners</span>
        <h1>Recent winners</h1>
        <p className="lede">
          Winners are listed by date. Mobile numbers are partly hidden — we never publish a full number or a name.
        </p>

        <div className="bar">
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} aria-label="Filter by date" />
          {date && <button type="button" className="chip" onClick={() => setDate('')}>Clear</button>}
          {!loading && data.length > 0 && (
            <span style={{ color: 'var(--muted)', fontSize: 14 }}>
              {data.length} winner{data.length === 1 ? '' : 's'} · <b className="win">{total.toLocaleString('en-IN')}</b> points won
            </span>
          )}
        </div>

        {loading && <div className="grid g3">{[0,1,2,3,4,5].map((i) => <div key={i} className="skel" />)}</div>}
        {error && <div className="card empty">{error}</div>}

        {!loading && !error && data.length === 0 && (
          <div className="card empty">No winners{date ? ` for ${fmtDate(date)}` : ''} yet.</div>
        )}

        {!loading && !error && data.length > 0 && (
          <div className="tbl-wrap">
            <table>
              <thead>
                <tr><th>Player</th><th>Market</th><th>Date</th><th>Bid</th><th>Won</th></tr>
              </thead>
              <tbody>
                {data.map((w, i) => (
                  <tr key={`${w.user}-${w.date}-${i}`}>
                    <td data-label="Player" className="mono" style={{ color: 'var(--ink)' }}>{w.user}</td>
                    <td data-label="Market" style={{ fontWeight: 700 }}>{w.game_name}</td>
                    <td data-label="Date" style={{ color: 'var(--muted)' }}>{fmtDate(w.date)}</td>
                    <td data-label="Bid">{Number(w.bid_points).toLocaleString('en-IN')}</td>
                    <td data-label="Won" className="win">{Number(w.win_points).toLocaleString('en-IN')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </PublicLayout>
  );
}
